import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { asArray } from "../utils/map";

const styles = theme => ({
  root: {
    bottom: theme.spacing(1)
  },
  divider: {
    color: theme.palette.primary.main
  },
  contentContainer: {
    textAlign: "Left",
    margin: "50px"
  },
  content: {
    width: "75%",
    marginBottom: "25px",
    textAlign: "Left"
  },
  buttonsContainer: {
    textAlign: "Right"
  },
  button: {
    textTransform: "none",
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
});

export const DeviceCommandsDialog = withStyles(styles)(
  ({
    actions,
    selectedAction,
    onActionChange,
    onClose,
    onSend,
    onKioskChange,
    classes,
    apps,
    onAppChange,
    selectedApp,
    showLaunchApp,
    showSetKioskApp,
    dialogTitle
  }) => (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      scroll="body"
      open
      spacing={0}
      className={classes.root}
      onClose={event => {
        event.stopPropagation();
        onClose();
      }}
      onClick={event => event.stopPropagation()}
    >
      <DialogTitle>
        <b>Send Command To [{dialogTitle}]</b>
      </DialogTitle>
      <DialogContent>
        <div className={classes.contentContainer}>
          <Select
            value={selectedAction}
            onChange={event => {
              event.stopPropagation();
              onActionChange(event.target.value);
            }}
            className={classes.content}
          >
            {asArray(actions).map(({ key, title }) => (
              <MenuItem key={key} value={key}>
                {title}
              </MenuItem>
            ))}
          </Select>

          {showLaunchApp && (
            <Select
              value={selectedApp}
              onChange={event => {
                event.stopPropagation();
                onAppChange(event.target.value);
              }}
              className={classes.content}
            >
              {apps.map(({ label, value }) => (
                <MenuItem value={value} key={value}>
                  {label}
                </MenuItem>
              ))}
              >
            </Select>
          )}
          {showLaunchApp && showSetKioskApp && (
            <FormControlLabel
              control={
                <Checkbox
                  onChange={event => onKioskChange(event.target.checked)}
                />
              }
              label="Set app as Kiosk App"
            />
          )}
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            aria-label="Edit"
            color="primary"
            variant="contained"
            className={classes.button}
            onClick={event => {
              event.stopPropagation();
              onSend();
              onClose();
            }}
          >
            Send Command
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
);
